import React, { FunctionComponent } from 'react';
import { Registry } from '../../formfy/types';
import { Link as RouterLink } from 'react-router-dom';
import { FormattedDate, FormattedMessage } from 'react-intl';

//MaterialUI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/configureStore';
import { Phase1CardOptions } from './Phase1CardOptions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1, 1, 1) /* top | horizontal | bottom */,
    },
    gridPaperContent: {
      flexGrow: 1,
    },
    gridItemMoreVertIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    paperNoProjects: {
      padding: theme.spacing(1),
    },
    flex: {
      display: 'flex',
    },
  })
);

type Props = {
  phase1Registry: Registry;
  phase1FieldIdsToNames: { [key: string]: string };
};

export const Phase1Card: FunctionComponent<Props> = ({ phase1Registry }) => {
  const classes = useStyles();
  const location = useLocation();
  const accessLevel = useSelector((state: RootState) => {
    const orgUser = state.organization.orgUser;
    if (orgUser !== 'not_initialized') {
      return orgUser?.organizationAccessLevel;
    }
  });

  const [phase1CreatedAt, setphase1CreatedAt] = React.useState<any>(null);
  React.useEffect(() => {
    if (phase1Registry.createdAt) {
      setphase1CreatedAt(phase1Registry.createdAt);
    }
  }, [phase1Registry]);

  return (
    <Paper elevation={1} className={classes.paper}>
      <Grid container className={classes.gridPaperContent} alignItems='center'>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} zeroMinWidth>
          <Typography
            variant='h6'
            align='left'
            color='textPrimary'
            gutterBottom
            noWrap
          >
            <Box paddingRight={1} component='span'>
              <FolderIcon />
            </Box>
            {phase1Registry.name}
          </Typography>
          <Typography
            variant='body1'
            align='left'
            color='textSecondary'
            gutterBottom
            noWrap
          >
            <FormattedMessage id='app.created-at' defaultMessage='Criado em:' />{' '}
            <FormattedDate
              value={phase1CreatedAt}
              year='numeric'
              month='numeric'
              day='numeric'
              //weekday="long"
            />
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} zeroMinWidth>
          <div className={classes.flex}>
            <Button
              variant='outlined'
              color='primary'
              fullWidth
              component={RouterLink}
              to={`${location.pathname.replace(/\/$/, '')}/phase1Id/${
                phase1Registry.phase1Id
              }`}
            >
              <FormattedMessage id='app.open' defaultMessage='Abrir' />
            </Button>
            {accessLevel === 'Admin' && (
              <Box marginLeft={1} marginRight={0}>
                <Phase1CardOptions phase1Registry={phase1Registry} />
              </Box>
            )}
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};
